import React from 'react'
import { OpportunityInvestmentProjectionSummaryProps } from '../../lib/types'

const OpportunityInvestmentProjectionSummary = ({
  expectedReturnLabel,
  selectedRangeLabel,
  potentialTotalValueLabel,
}: OpportunityInvestmentProjectionSummaryProps) => (
  <div className='opportunity-investment-projection-summary'>
    <div className='opportunity-investment-projection-summary-item'>
      <span className='opportunity-investment-projection-summary-label'>Expected return</span>
      <span className='opportunity-investment-projection-summary-value'>{expectedReturnLabel}</span>
    </div>
    <div className='opportunity-investment-projection-summary-item'>
      <span className='opportunity-investment-projection-summary-label'>Selected range</span>
      <span className='opportunity-investment-projection-summary-value'>{selectedRangeLabel}</span>
    </div>
    <div className='opportunity-investment-projection-summary-item opportunity-investment-projection-summary-item--featured'>
      <span className='opportunity-investment-projection-summary-label'>Potential total value</span>
      <span className='opportunity-investment-projection-summary-value'>
        {potentialTotalValueLabel}
      </span>
    </div>
  </div>
)

export default OpportunityInvestmentProjectionSummary
